import App from '@/views/constants/app';
import NewPeriod from '@/views/constants/period-new';
import Validator from '@/views/validations/period-new';

import ReportsOfSicknessView from '@/views/constants/reports-of-sickness';
import ReportsOfSicknessResource from '@/resources/constants/reports-of-sickness';

import { Period } from '@/resources/models/period';

const state = {
  newPeriod: new Period(),
  _newPeriodCorrespondingReportOfSickness: null
};

const getters = {
  newPeriod: state => state.newPeriod,

  newPeriodRequiredFields: state => Validator.requiredFields(state.newPeriod),
  newPeriodValidations: state => Validator.validate(state.newPeriod, state._newPeriodCorrespondingReportOfSickness)
};

const actions = {
  [NewPeriod.Actions.Form.CHANGE] ({ commit }, data) {
    commit(NewPeriod.Mutations.Form.CHANGE, data);
  },

  [ReportsOfSicknessResource.Actions.Period.Create.SUCCESS] ({ commit }) {
    commit(NewPeriod.Mutations.CLEAR);
  },

  [NewPeriod.Actions.Cancel.DO] ({ commit }) {
    commit(NewPeriod.Mutations.CLEAR);
  },

  [ReportsOfSicknessView.Actions.Tabs.CLOSE] ({ commit }, tab) {
    if (tab.component === 'NewPeriod') {
      commit(NewPeriod.Mutations.CLEAR);
    }
  },

  [ReportsOfSicknessView.Actions.Tabs.OPEN_PERIOD] ({ commit }, data) {
    commit(NewPeriod.Mutations.SET_CORRESPONDING_ROS, data);
  }
};

const mutations = {
  [NewPeriod.Mutations.Form.CHANGE] (state, payload) {
    state.newPeriod[payload.attribute] = payload.value;
  },

  [NewPeriod.Mutations.CLEAR] (state) {
    state.newPeriod = new Period();
    state._newPeriodCorrespondingReportOfSickness = null;
  },

  [App.Mutations.CLEAR] (state) {
    state.newPeriod = new Period();
    state._newPeriodCorrespondingReportOfSickness = null;
  },

  [NewPeriod.Mutations.SET_CORRESPONDING_ROS] (state, payload) {
    state._newPeriodCorrespondingReportOfSickness = payload;
  }
};

export default {
  namespaced: false,
  state,
  getters,
  actions,
  mutations
};
